// Вложение сообщения. Бэк всегда отдаёт массив files (пустой, если вложений
// нет), неизвестные значения приходят как null.
export interface IChatFile {
  url: string;
  name?: string | null;
  size?: number | null;
  mime?: string | null;
}

// USER — сообщение пользователя, SYSTEM — событие платформы (текст собираем сами)
export type MessageType = "USER" | "SYSTEM";

// Публикация из системного сообщения о её создании. Время в schedule — UTC
export interface IChatPublicationInfo {
  id: number;
  order?: { id: number; name: string } | null;
  place?: {
    id: number;
    name: string;
    avatar?: string | null;
    url?: string | null;
    social?: string | null;
  } | null;
  schedule?: {
    id: number;
    dateBegin: string;
    dateEnd: string;
    timeBegin: string;
    timeEnd: string;
  }[];
  advertiser?: { id: number; name?: string | null; avatar?: string | null } | null;
  publisher?: { id: number; name?: string | null; avatar?: string | null } | null;
}

export interface IMessage {
  type?: MessageType;
  systemEvent?: string | null;
  payload?: Record<string, any> | null;
  publicationInfo?: IChatPublicationInfo | null;
  ticketId?: number;
  chatId: number;
  content: string;
  isRead: boolean;
  created: Date | string;
  messageId: number;
  replyTo: number | null;
  status: string;
  userId: number;
  userType: string;
  files?: IChatFile[];
}

export interface IChat {
  notRead: number;
  id: number;
  kind?: "CHANNEL" | "PUBLICATION" | "DIRECT";
  // Канал канального чата; у прямого и старого чата по публикации — null
  place?: { id: number; social: string } | null;
  // Все привязанные публикации в порядке привязки
  publications?: { id: number; linkedAt?: string | null; publicationInfo?: any }[];
  // У канального чата — последняя привязанная публикация
  publicationId: number | null;
  title: string;
  messages: IMessage[] | null;
  waiting: boolean;
  status: string;
  created: Date | string;
  advertiserId?: number;
  publicationInfo?: any;
}

export enum ChatUserType {
  ADVERTISER = "ADVERTISER",
  PUBLISHER = "PUBLISHER",
  SUPPORT = "SUPPORT",
  ADMIN = "ADMIN",
  CLIENT = "CLIENT",
  SYSTEM = "SYSTEM",
}

export interface ISendMessage {
  chatId: number;
  replyTo?: number | null;
  userType?: ChatUserType;
  content?: string;
  status?: string;
  files?: IChatFile[];
}

export interface ISendSystemMessage {
  ticketId: number;
  chatId?: number;
  replyTo?: number | null;
  userType?: ChatUserType;
  content?: string;
  status?: string;
  type?: string;
  recipientType?: ChatUserType;
  files?: IChatFile[];
}

export interface IMessageChat {
  type?: MessageType;
  systemEvent?: string | null;
  payload?: Record<string, any> | null;
  publicationInfo?: IChatPublicationInfo | null;
  id: number;
  sender: {
    id: number;
  };
  message: string;
  content: string;
  userId: string;
  ticketId?: number;
  status: string;
  created: string;
  userType: string;
  files?: IChatFile[];
}
